import { jsx as a } from "react/jsx-runtime";
import { buildClassNames as d } from "../../style/build-class-names.mjs";
const m = (t, o) => {
  const n = parseInt(t, 16);
  return Number(n + o).toString(16);
}, g = "abcdefghijklmnopqrstuvwxyz", f = "1f1e6", r = g.split("").reduce((t, o, n) => ({
  ...t,
  // construct alphabet by incrementing A letter codepoint value
  [o]: m(f, n)
}), {}), p = (t) => {
  const o = t[0], n = t[1];
  return !o || !n ? "" : [r[o], r[n]].join("-");
}, j = ({
  iso2: t,
  size: o = "24px",
  protocol: n = "https",
  disableLazyLoading: s,
  className: c,
  ...e
}) => {
  if (!t)
    return /* @__PURE__ */ a("img", { width: o, height: o, ...e });
  const i = p(t), l = `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${i}.svg`;
  return /* @__PURE__ */ a(
    "img",
    {
      alt: t,
      className: d({
        addPrefix: ["flag-emoji"],
        rawClassNames: [c]
      }),
      src: l,
      width: o,
      height: o,
      draggable: !1,
      "data-country": t,
      loading: s ? void 0 : "lazy",
      ...e
    }
  );
};
export {
  j as FlagEmoji
};
